import { Text } from "@musa.tech/design-system";
import { SuccessRateGauge } from "./SuccessRateGauge";
import { FaultReasonsList } from "./FaultReasonsList";
import type { FaultReasonBreakdown } from "@/integrations/agreements/client";

interface SuccessRateWidgetProps {
  successRatePercent: number;
  faultReasons: FaultReasonBreakdown[];
}

/**
 * Widget "Taxa de sucesso" (Figma node 233:2682) — gauge do percentual de
 * coletas concluídas com sucesso + ranking dos motivos de falha mais
 * frequentes do período. Divide a linha com o "Volume coletado" à esquerda
 * (proporção 871/279 do Figma); a largura vem do wrapper em Dashboard.tsx.
 */
export const SuccessRateWidget = ({
  successRatePercent,
  faultReasons,
}: SuccessRateWidgetProps) => (
  <div className="flex h-full w-full flex-col items-start gap-4 rounded-2xl bg-white p-6 transition-shadow duration-200 hover:shadow-md motion-reduce:transition-none">
    <Text className="text-xl font-light leading-7 tracking-[1px] text-black">
      Taxa de sucesso
    </Text>

    {/* `flex justify-center`: o gauge tem `max-w-[223px]`, bem menor que o
        card no mobile (que aqui vai full width) — sem centralizar, sobrava
        espaço vazio à direita. Título e motivos de falha continuam à
        esquerda (`items-start` do container). */}
    <div className="flex w-full justify-center">
      <SuccessRateGauge value={successRatePercent} />
    </div>

    <div className="h-px w-full bg-neutral-300" />

    <FaultReasonsList reasons={faultReasons} />
  </div>
);
